import { Children, memo } from 'react';

import { ComparisonViewImpl, ComparisonViewProps } from './ComparisonView.js';

export interface ComparisonProps {
  /**
   * The ratio of the two views. Defaults to 0.5.
   * This means that the left view will be 50% of the
   */
  ratio?: number;
  /**
   * The two views to compare.
   */
  children?: React.ReactElement<ComparisonViewProps>[];
}

/**
 * Creates a side-by-side comparison of two views.
 *
 * ```tsx
 * import { Comparison, ComparisonView } from '@react-three/drei';
 *
 * export default function App() {
 *  return (
 *    <Canvas>
 *      <Comparison>
 *        <ComparisonView>
 *          <mesh>
 *            <boxGeometry />
 *            <meshBasicMaterial color="red" />
 *          </mesh>
 *        </ComparisonView>
 *        <ComparisonView>
 *          <mesh>
 *            <boxGeometry />
 *            <meshBasicMaterial color="blue" />
 *          </mesh>
 *        </ComparisonView>
 *      </Comparison>
 *   </Canvas>
 * );
 */
export const Comparison: React.FC<ComparisonProps> = memo(({ children, ratio = 0.5 }) => {
  return (
    <>
      {Children.map(children, (child, index) => (
        <ComparisonViewImpl index={index} {...child?.props} ratio={ratio} />
      ))}
    </>
  );
});

export default Comparison;
